// src/components/Dashboard.tsx
import logo from "../../assets/spizop-logo.png";
import maleProfilePic from "../../assets/profile_pic_male.jpeg";
import femaleProfilePic from "../../assets/profile_pic_female.png";
import closeIcon from "../../assets/close_icon.png";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios"; // Import axios for API calls
import "./dashboard.scss"; // Create and import a CSS file for styling

// Define TypeScript interface for user details
interface UserDetails {
  name: string;
  email: string;
  phoneNumber: string;
  role: string;
  gender: string;
}

const Dashboard: React.FC = () => {
  const [role, setRole] = useState<string>(""); // State to store role
  const [userDetails, setUserDetails] = useState<UserDetails | null>(null); // State to store user details
  const [showOverlay, setShowOverlay] = useState<boolean>(false); // State to toggle overlay
  const [loading, setLoading] = useState<boolean>(true); // Add loading state
  const navigate = useNavigate();
  const isInitialRender = useRef(true); // Track initial render

  const [totalActiveChatSupportCount, setTotalActiveChatSupportCount] =
    useState(0);
  const [totalCallbackRequests, setTotalCallbackRequests] = useState(0);
  const [totalDietsToBeSent, setTotalDietsToBeSent] = useState(0);

  // Function to fetch user details from the API
  const fetchUserDetails = async () => {
    try {
      // Get email and token from localStorage
      const email = localStorage.getItem("email");
      const token = localStorage.getItem("token");

      // If email or token is missing, redirect to login
      if (!email || !token) {
        navigate("/");
        return;
      }

      // Configure headers for the API request
      const config = {
        headers: {
          Authorization: `Bearer ${token}`, // Set JWT token in the Authorization header
        },
      };

      // Make API call to fetch user details
      const response = await axios.get(
        `https://spizopapi.fitoja.in/api/get-employee-details/${email}`,
        config
      );

      // Set user details and role in state
      setUserDetails(response.data);
      setRole(response.data.role);
    } catch (error) {
      handleLogout(); // Logout and redirect if there's an error
    } finally {
      setLoading(false); // Stop the loading indicator once API responds
    }
  };

  // Logout function
  const handleLogout = () => {
    localStorage.removeItem("token"); // Clear token on logout
    localStorage.removeItem("email"); // Clear email on logout
    navigate("/login"); // Redirect to login
  };

  // useEffect hook to fetch user details on component mount
  useEffect(() => {
    if (isInitialRender.current) {
      fetchUserDetails();

      isInitialRender.current = false; // Prevent further calls
    }
  }, []);

  return (
    <div className="dashboard-container">
      {/* Loading indicator */}
      {loading && (
        <div className="loading-indicator">
          <div className="spinner"></div>
          <p>Loading, please wait...</p>
        </div>
      )}

      {!loading && (
        <>
          {/* Header Section */}
          <header className="dashboard-header">
            <div className="logo" onClick={() => navigate("/dashboard")}>
              <img src={logo} />
            </div>
            <div
              className="profile-section"
              onClick={() => setShowOverlay(!showOverlay)}
            >
              {/* Display Male or Female profile based on user's gender */}
              {/* <img
            className="profile-pic"
            src={
              userDetails?.gender == "Male"
                ? maleProfilePic
                : femaleProfilePic
            }
            alt="Profile"
          /> */}
              <img className="profile-pic" src={maleProfilePic} alt="Profile" />
            </div>
          </header>

          {/* Overlay for showing user details */}
          {showOverlay && userDetails && (
            <div className="profile-overlay">
              <div className="overlay-content">
                <img
                  className="close_icon"
                  onClick={() => setShowOverlay(false)}
                  src={closeIcon}
                />
                <p>
                  <strong>Name:</strong> {userDetails.name}
                </p>
                <p>
                  <strong>Email:</strong> {userDetails.email}
                </p>
                <p>
                  <strong>Phone Number:</strong> {userDetails.phoneNumber}
                </p>
                <p>
                  <strong>Role:</strong> {userDetails.role}
                </p>
                <p>
                  <strong>Gender:</strong> {userDetails.gender}
                </p>
                <button className="logout-button" onClick={handleLogout}>
                  Logout
                </button>
              </div>
            </div>
          )}

          {/* Dashboard Cards Section */}
          <div className="cards-container">
            <div className="cards-grid">
              {(role == "Owner" || role == "Developer") && (
                <div
                  className="card"
                  onClick={() => navigate("/employee-portal")}
                >
                  <h3>Employee Panel</h3>
                  <p>
                    Add new employee (Admin or Content writers), Remove an
                    employee, View employee's detail.
                  </p>
                </div>
              )}
              {(role == "Owner" || role == "Developer" || role == "Sales") && (
                <div className="card" onClick={() => navigate("/products")}>
                  <h3>Products</h3>
                  <p>
                    Upload new products, Manage all products for Spizop Store.
                  </p>
                </div>
              )}
              {(role == "Owner" || role == "Developer" || role == "Sales") && (
                <div className="card" onClick={() => navigate("/track-orders")}>
                  <h3>Track Orders</h3>
                  <p>
                    Track or Update and Manage all orders.
                  </p>
                </div>
              )}
              {(role == "Owner" || role == "Developer" || role == "Sales") && (
                <div className="card" onClick={() => navigate("/total-users")}>
                  <h3>Total Users</h3>
                  <p>
                    Do you know total how may users have registered in your app?
                  </p>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Dashboard;
